import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { AttendingLeavingService } from '../../../../shared/services/hr/attending-leaving.service';
import { FingerDevicesService } from '../../finger-devices.service';
import { GeneralCalcSalaryInputsComponent } from '../../general-calc-salary-inputs/general-calc-salary-inputs.component';
import { DxDataGridComponent } from 'devextreme-angular';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import * as XLSX from 'xlsx';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-edit-attending-leaving',
  templateUrl: './edit-attending-leaving.component.html',
  styleUrls: ['./edit-attending-leaving.component.scss']
})
export class EditAttendingLeavingComponent implements OnInit {

  // ========== Shared ==========
  LOCALIZATION_LOCAL_STORAGE_KEY = 'Language';
  currentLang: any;
  employeeDropDown: [] = [];
  selectedTabIndex = 0;
showResultPopup = false;

isDeleting = false;
saveResult: any = null;
  // ========== Tab 1: Grid View ==========
  @ViewChild('dataGridVar', { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild('salaryInputs', { static: false }) salaryInputsComponent: GeneralCalcSalaryInputsComponent;

  filterFormData: any = {};
  gridDataSource: any[] = [];
  modifiedRows: { [key: string]: any } = {}; // تتبع الـ rows المعدلة
  isSavingGrid = false;

  // ========== Tab 2: Excel Import ==========
  @ViewChild('excelGridVar', { static: false }) excelGrid: DxDataGridComponent;

  excelDataSource: any[] = [];
  isUploadingBulk = false;
  bulkResults: any = null;
  hasExcelData = false;
selectedIds: number[] = [];
  constructor(
    public objectsService: ObjectsService,
    public translate: TranslateService,
    public attendingLeavingService: AttendingLeavingService,
    public gt: genericCustomStoreService,
    private fingerDevicesService: FingerDevicesService
  ) {
    this.currentLang = localStorage.getItem(this.LOCALIZATION_LOCAL_STORAGE_KEY);

    gt.getdropdowndata('Employee').subscribe((res: any) => {
      this.employeeDropDown = res;
    });
  }

  ngOnInit(): void {}

  // ========== Tab 1: Filter & Grid ==========

  onFormDataChanged(formData: any): void {
    this.filterFormData = formData;
  }

  resetFilter(): void {
    if (this.salaryInputsComponent) {
      this.salaryInputsComponent.resetForm();
      this.filterFormData = {};
      this.gridDataSource = [];
      this.modifiedRows = {};
    }
  }

  applyFilter(): void {
    const filterData = this.salaryInputsComponent.getFormData();
    const requestData = this.prepareRequestData(filterData);

    this.attendingLeavingService.getAttendanceWithFilter(requestData).subscribe({
      next: (res: any) => {
        this.gridDataSource = this.processAttendanceData(res.data || res);
        this.modifiedRows = {};
        if (this.dataGrid) this.dataGrid.instance.refresh();
      },
      error: (err) => console.error('Error fetching data', err)
    });
  }

  prepareRequestData(formData: any): any {
    const formatDate = (date: any): string | null => {
      if (!date) return null;
      return date instanceof Date ? date.toISOString() : new Date(date).toISOString();
    };
    return {
      FromDate: formatDate(formData.fromDate),
      ToDate: formatDate(formData.toDate),
      EmployeeIds: formData.employeeIds || [],
      JobTitleIds: formData.jobTitleIds || [],
      DepartmentIds: formData.departmentIds || [],
      WorkSystemIds: formData.workSystemIds || [],
      ManagementIds: formData.managementIds || [],
      BranchIds: formData.branchIds || [],
    };
  }


  onRowUpdated(e: any): void {
    const key = e.key; // employeeId_date
    this.modifiedRows[key] = e.data;
  }

saveGridChanges(): void {
  debugger;

  const modifiedKeys = Object.keys(this.modifiedRows);

  if (modifiedKeys.length === 0) {
    notify('لا توجد تعديلات لحفظها', 'info', 2000);
    return;
  }

  this.isSavingGrid = true;


  const items = modifiedKeys.map(key => {

    const originalRow = this.gridDataSource.find(item => item._key === key) || {};
  
    const finalRow = { ...originalRow, ...this.modifiedRows[key] };


    const formatTimeForBackend = (timeStr: any) => {
      if (!timeStr) return null;
      // إذا كان الوقت مكتوباً بالفعل بصيغة HH:mm أو HH:mm:ss
      const parts = timeStr.toString().split(':');
      if (parts.length === 2) return `${timeStr}:00`;
      if (parts.length === 3) return timeStr;
      return null;
    };

   
    let formattedDate = finalRow.dateOfDay;
    if (formattedDate && formattedDate.includes('T')) {
      formattedDate = formattedDate.split('T')[0];
    }

  return {
  EmployeeId: Number(finalRow.employeeId) || 0,
  DurationWorkSystemId: Number(finalRow.durationWorkSystemId) || 0,
  DateOfDay: formattedDate,
  Attending_LeavingType: finalRow.attending_LeavingType, // ✅ بدل الـ 3 الثابتة
  Description: finalRow.description || '',
  TimeAttending: finalRow.attending_LeavingType === 1 
    ? formatTimeForBackend(finalRow.time) 
    : null,
  TimeLeave: finalRow.attending_LeavingType === 2 
    ? formatTimeForBackend(finalRow.time) 
    : null,
};
  });

 
  console.log('Payload being sent to backend:', { items });

  this.attendingLeavingService.updateAttending({ items }).subscribe({
    next: (res: any) => {
      this.isSavingGrid = false;
      this.modifiedRows = {};
       this.saveResult = res;       
  this.showResultPopup = true; 
      notify(`تم حفظ ${items.length} سجل بنجاح`, 'success', 3000);
      this.applyFilter();
    },
    error: (err) => {
      this.isSavingGrid = false;
      notify('حدث خطأ أثناء الحفظ', 'error', 3000);
      console.error(err);
    }
  });
}
  updateRow(options: any): void {
    debugger
    options.newData = Object.assign(options.oldData, options.newData);
  }

 

 onFileUploaded(event: any): void {
  const file = event.target.files[0];
  if (!file) return;
  debugger;
  const reader = new FileReader();
  reader.onload = (e: any) => {
    const data = new Uint8Array(e.target.result);
    const workbook = XLSX.read(data, { type: 'array' });
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    const rawData: any[] = XLSX.utils.sheet_to_json(worksheet);
    console.log(rawData);
    
    if (rawData.length === 0) {
      notify('الملف فارغ!', 'warning', 3000);
      return;
    }

   
    this.excelDataSource = rawData.map((row: any, index: number) => {
    
      const extractedCode = row[' '] ?? row['EmployeeCode'] ?? row['كود الموظف'] ?? '';

      return {
        tempId: index, 
        employeeCode: String(extractedCode).trim(), 
        employeeName: row['اسم الموظف'] || row['EmployeeName'] || '',
        dateOfDay: this.formatExcelDate(row['التاريخ'] || row['Date']),
        timeAttending: this.parseTime(row['وقت الحضور'] || row['TimeAttending']),
        timeLeave: this.parseTime(row['وقت الانصراف'] || row['TimeLeave']),
      };
    });

    this.hasExcelData = true;
    this.bulkResults = null;

    if (this.excelGrid) this.excelGrid.instance.refresh();
    notify(`تم تحميل ${this.excelDataSource.length} سجل، راجع البيانات قبل الإرسال`, 'info', 3000);
  };

  reader.readAsArrayBuffer(file);
  event.target.value = '';
}

  
  submitExcelData(): void {
    if (this.excelDataSource.length === 0) {
      notify('لا توجد بيانات للإرسال', 'warning', 2000);
      return;
    }

    this.isUploadingBulk = true;
    this.bulkResults = null;
debugger;
    const items = this.excelDataSource.map(({ tempId, ...rest }) => rest);

 
     this.attendingLeavingService.updateAttending({ items }).subscribe({
      next: (res: any) => {
        this.bulkResults = res;
        this.isUploadingBulk = false;
             this.saveResult = res;        
  this.showResultPopup = true; 
        if (res.failedCount === 0) {
          notify('تم رفع جميع السجلات بنجاح', 'success', 3000);
          this.excelDataSource = [];
          this.hasExcelData = false;
        } else {
          notify(`تم رفع ${res.successCount} سجل، فشل ${res.failedCount} سجل`, 'warning', 5000);
        }
      },
      error: (err) => {
        this.isUploadingBulk = false;
        notify('حدث خطأ أثناء الرفع', 'error', 3000);
        console.error(err);
      }
    });
  }

  clearExcelData(): void {
    this.excelDataSource = [];
    this.hasExcelData = false;
    this.bulkResults = null;
  }

  exportFailedRows(): void {
    if (!this.bulkResults?.errors?.length) {
      notify('لا توجد أخطاء للتصدير', 'info', 2000);
      return;
    }

    const failedData = this.bulkResults.errors.map((error: any) => ({
      'السطر': error.rowIndex,
      'اسم الموظف': error.employeeName || '',
      'التاريخ': error.dateOfDay ? new Date(error.dateOfDay).toLocaleDateString('ar-EG') : '',
      'الأخطاء': error.errors.join(', ')
    }));

    const ws = XLSX.utils.json_to_sheet(failedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'الأخطاء');
    ws['!cols'] = [{ wch: 10 }, { wch: 25 }, { wch: 15 }, { wch: 60 }];
    XLSX.writeFile(wb, 'حضور_فاشل_لإعادة_التعديل.xlsx');
    notify('تم تصدير الأخطاء بنجاح', 'success', 2000);
  }

  downloadTemplate(): void {
    const template = [
      { 'EmployeeCode': '352', 'اسم الموظف': 'أحمد محمد', 'التاريخ': '15/01/2024', 'وقت الحضور': '08:00', 'وقت الانصراف': '17:00' },
      { 'EmployeeCode': '101', 'اسم الموظف': 'محمد علي', 'التاريخ': '15/01/2024', 'وقت الحضور': '08:30', 'وقت الانصراف': '16:45' }
    ];
    const ws = XLSX.utils.json_to_sheet(template);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'قالب الحضور والانصراف');
    ws['!cols'] = [{ wch: 15 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 }];
    XLSX.writeFile(wb, 'قالب_الحضور_والانصراف.xlsx');
    notify('تم تحميل القالب بنجاح', 'success', 2000);
  }

  // ========== Shared Helpers ==========

processAttendanceData(rawData: any[]): any[] {
  return rawData.map((curr, index) => ({
    _key: `${curr.id}_${index}`,
    id: curr.id,
    employeeId: curr.employeeId,
    employeeCode: curr.employeecode || '',
    employeeName: curr.employeeName,
    dateOfDay: curr.dateOfDay ? curr.dateOfDay.split('T')[0] : '',
    durationWorkSystemId: curr.durationWorkSystemId,
    durationName: curr.durationName,
    attending_LeavingType: curr.attending_LeavingType,
    time: curr.time ? curr.time.substring(0, 5) : null,  // "08:02:00" → "08:02"
    description: curr.description,
  }));
}
  formatExcelDate(excelDate: any): string {
    if (!excelDate) return new Date().toISOString();
    if (typeof excelDate === 'number') {
      return new Date((excelDate - 25569) * 86400 * 1000).toISOString();
    }
    if (typeof excelDate === 'string') {
      const parts = excelDate.split('/');
      if (parts.length === 3) return new Date(`${parts[2]}-${parts[1]}-${parts[0]}`).toISOString();
    }
    return new Date(excelDate).toISOString();
  }

  parseTime(timeValue: any): string | null {
    if (!timeValue) return null;
    if (typeof timeValue === 'number') {
      const totalSeconds = Math.round(timeValue * 24 * 60 * 60);
      const h = Math.floor(totalSeconds / 3600);
      const m = Math.floor((totalSeconds % 3600) / 60);
      const s = totalSeconds % 60;
      return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
    }
    if (typeof timeValue === 'string') {
      const parts = timeValue.split(':');
      if (parts.length === 2) return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}:00`;
      if (parts.length === 3) return `${parts[0].padStart(2, '0')}:${parts[1].padStart(2, '0')}:${parts[2].padStart(2, '0')}`;
    }
    return timeValue.toString();
  }
  get modifiedCount(): number {
  return Object.keys(this.modifiedRows).length;
}
//Delete



onSelectionChanged(e: any): void {
  this.selectedIds = e.selectedRowsData
    .map((row: any) => row.id)
    .filter((id: number) => !!id);
}

deleteSelected(): void {
  if (this.selectedIds.length === 0) return;

  this.isDeleting = true;
  this.attendingLeavingService.deleteList({ ids: this.selectedIds }).subscribe({
    next: (res: any) => {
      this.isDeleting = false;
      this.saveResult = res;
      this.showResultPopup = true;
      notify(`تم حذف ${res.deletedCount} سجل`, 'success', 3000);
      this.selectedIds = [];
      this.applyFilter(); // تحديث الـ grid
    },
    error: (err) => {
      this.isDeleting = false;
      notify('حدث خطأ أثناء الحذف', 'error', 3000);
      console.error(err);
    }
  });
}
}